import { render } from "./TemaLink.vue?vue&type=template&id=70771a26"
import script from "./TemaLink.vue?vue&type=script&lang=js"
export * from "./TemaLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__